import { queryOptions } from "@tanstack/react-query";
import { PUBLIC_QUERY_STALE_TIME } from "./public-query-cache";
import {
  adminGetProject,
  adminListProjects,
  getPublishedProject,
  getPublishedMunicipality,
  listPublishedProjects,
} from "@/lib/projects.functions";

export const publishedProjectsQuery = (lang = "nl") =>
  queryOptions({
    queryKey: ["projects", "published", "list", lang],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => listPublishedProjects({ data: { lang } }),
  });

export const publishedProjectQuery = (slug: string, lang = "nl") =>
  queryOptions({
    queryKey: ["projects", "published", slug, lang],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => getPublishedProject({ data: { slug, lang } }),
  });


export const publishedMunicipalityQuery = (slug: string) =>
  queryOptions({
    queryKey: ["projects", "published", "municipality", slug],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => getPublishedMunicipality({ data: { slug } }),
  });

export const adminProjectsQuery = queryOptions({
  queryKey: ["projects", "admin", "list"],
  queryFn: () => adminListProjects(),
});

export const adminProjectQuery = (slug: string) =>
  queryOptions({
    queryKey: ["projects", "admin", slug],
    queryFn: () => adminGetProject({ data: { slug } }),
    enabled: slug !== "nieuw",
  });
